import { AlertProps } from "@chakra-ui/react";
import { SubscriptionStatus } from "__generated__/serverGql/graphql";

type ColorScheme = "green" | "blue" | "orange" | "red" | "yellow";
type AlertStatus = Required<AlertProps>["status"];

export const COLOR_TO_ALERT_STATUS: Record<ColorScheme, AlertStatus> = {
  green: "success",
  blue: "info",
  orange: "warning",
  yellow: "warning",
  red: "error",
};

export type StatusConfig = {
  title: string;
  colorScheme: ColorScheme;
};

export const SUBSCRIPTION_STATUS_CONFIG: Record<
  SubscriptionStatus,
  StatusConfig
> = {
  [SubscriptionStatus.ACTIVE]: {
    title: "Active",
    colorScheme: "green",
  },
  [SubscriptionStatus.TRIALING]: {
    title: "Trial period active",
    colorScheme: "blue",
  },
  [SubscriptionStatus.PAST_DUE]: {
    title: "Payment failed - retrying",
    colorScheme: "orange",
  },
  [SubscriptionStatus.UNPAID]: {
    title: "Invoice unpaid",
    colorScheme: "red",
  },
  [SubscriptionStatus.CANCELED]: {
    title: "Subscription canceled",
    colorScheme: "red",
  },
  [SubscriptionStatus.INCOMPLETE]: {
    title: "Payment required",
    colorScheme: "yellow",
  },
  [SubscriptionStatus.INCOMPLETE_EXPIRED]: {
    title: "Initial payment expired",
    colorScheme: "red",
  },
  [SubscriptionStatus.PAUSED]: {
    title: "Trial ended - payment needed",
    colorScheme: "yellow",
  },
};
